/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccE2eFixtureResetDocumentsByRelationTypeRequest
 */
export interface PccE2eFixtureResetDocumentsByRelationTypeRequest {
    /**
     * 
     */
    mode: PccE2eFixtureResetDocumentsByRelationTypeRequestModeEnum;
    /**
     * 
     */
    relation_type: PccE2eFixtureResetDocumentsByRelationTypeRequestRelationTypeEnum;
}


/**
 * @export
 */
export const PccE2eFixtureResetDocumentsByRelationTypeRequestModeEnum = {
    Documents: 'documents',
} as const;
export type PccE2eFixtureResetDocumentsByRelationTypeRequestModeEnum = typeof PccE2eFixtureResetDocumentsByRelationTypeRequestModeEnum[keyof typeof PccE2eFixtureResetDocumentsByRelationTypeRequestModeEnum];

/**
 * @export
 */
export const PccE2eFixtureResetDocumentsByRelationTypeRequestRelationTypeEnum = {
    ScreenerDocument: 'screener_document',
    ScreenerAdditionalDocument: 'screener_additional_document',
    ScreenerGeneratedDocument: 'screener_generated_document',
} as const;
export type PccE2eFixtureResetDocumentsByRelationTypeRequestRelationTypeEnum = typeof PccE2eFixtureResetDocumentsByRelationTypeRequestRelationTypeEnum[keyof typeof PccE2eFixtureResetDocumentsByRelationTypeRequestRelationTypeEnum];


/**
 * Check if a given object implements the PccE2eFixtureResetDocumentsByRelationTypeRequest interface.
 */
export function instanceOfPccE2eFixtureResetDocumentsByRelationTypeRequest(value: object): value is PccE2eFixtureResetDocumentsByRelationTypeRequest {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (value['mode'] !== 'documents') return false;
    
    if (!('relation_type' in value) || value['relation_type'] === undefined) return false;
    return true;
}

export function PccE2eFixtureResetDocumentsByRelationTypeRequestFromJSON(json: any): PccE2eFixtureResetDocumentsByRelationTypeRequest {
    return PccE2eFixtureResetDocumentsByRelationTypeRequestFromJSONTyped(json, false);
}

export function PccE2eFixtureResetDocumentsByRelationTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccE2eFixtureResetDocumentsByRelationTypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': json['mode'],
        'relation_type': json['relation_type'],
    };
}

export function PccE2eFixtureResetDocumentsByRelationTypeRequestToJSON(json: any): PccE2eFixtureResetDocumentsByRelationTypeRequest {
    return PccE2eFixtureResetDocumentsByRelationTypeRequestToJSONTyped(json, false);
}

export function PccE2eFixtureResetDocumentsByRelationTypeRequestToJSONTyped(value?: PccE2eFixtureResetDocumentsByRelationTypeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mode': value['mode'],
        'relation_type': value['relation_type'],
    };
}

